import script from "./CaskBaseResetPasswd.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskBaseResetPasswd.vue?vue&type=script&setup=true&lang=js"

import "./CaskBaseResetPasswd.vue?vue&type=style&index=0&id=c856e7c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c856e7c8"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QInput,QIcon,QBtn,QCheckbox});
